import React from 'react';
import { Box, ButtonProps, withStyles } from '@material-ui/core';
import FsBody from 'ui-elements/typography/FsBody';
import FsButton from 'ui-elements/buttons/FsButton';

export const Paragraph = withStyles(() => ({
  root: {},
}))(FsBody);

export const ButtonWrapperBox = withStyles(({ spacing }) => ({
  root: {
    marginTop: spacing(2),
  },
}))(Box);

export const ContentBox = withStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(2),
  },
}))(Box);

export const ActionButton = withStyles(() => ({}))((props: ButtonProps) => (
  <FsButton {...props} variant="outlined" color="primary" minWidth={160} />
));
